import { AttrField, OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import TaskBoardBase from '@/data/models/domain/tasks/TaskBoardBase'

@OrmModel(modelNames.TASK_BOARD)
export default class TaskBoard extends TaskBoardBase {
  @AttrField(null)
  public override archivedAt: null
}
